import { createContext } from 'react';
import {
  DataRoomNdaSigner,
  DataRoomNdaSigning,
} from 'router/subrouters/DataRoom/models/DataRoomNDA';
import utils from 'utils';

type DataRoomNdaTableContextProps = {
  openNdaDrawer: (
    signer: DataRoomNdaSigner,
    signing: DataRoomNdaSigning,
  ) => void;
  openNdaModal: (signer: DataRoomNdaSigner) => void;
};

export default createContext<Partial<DataRoomNdaTableContextProps>>({
  openNdaDrawer: utils.noop,
  openNdaModal: utils.noop,
});
